import React, { useEffect, useId, useRef } from 'react'
import { Flex } from '../../../core-components'
import { Skeleton, SkeletonLine } from '../../../../old/skeleton'

type SelectItemPlaceholderProps = {
  'data-test-id'?: string
  onIntersection?: () => unknown
  intersectionMargin?: string
}

export const SelectItemPlaceholder = ({
  onIntersection,
  intersectionMargin,
}: SelectItemPlaceholderProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const id = useId()

  const onIntersectionRef = useRef(onIntersection)
  const hasIntersectionObserver = onIntersection !== undefined

  useEffect(() => {
    onIntersectionRef.current = onIntersection
  }, [onIntersection])

  useEffect(() => {
    if (!hasIntersectionObserver) {
      return
    }
    const element = ref.current
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          onIntersectionRef.current?.()
        }
      },
      {
        root: element?.closest('ul'),
        rootMargin: intersectionMargin,
        threshold: 1,
      }
    )

    if (element) {
      observer.observe(element)
    }

    return () => observer.disconnect()
  }, [hasIntersectionObserver, intersectionMargin])

  return (
    <Flex ref={ref} alignItems='center'>
      <Skeleton height={14} width={200} id={id}>
        <SkeletonLine y={3} width={200} />
      </Skeleton>
    </Flex>
  )
}
